export interface Sys {
    id: string;
}
export const Sys_query: string = `
    sys {
        id
    }`;
